// Wave UX-2.3 #18 (2026-05-23) — 공용 toast 통일.
// 사용:
//   import { showToast } from './Toast';
//   showToast(t('toastFavoriteAdded'));
//   showToast(t('toastFavoriteError'), { variant: 'error' });
// Layout 에 ToastHost 1회 mount → window.dispatchEvent('autodex-toast') 받아서 표시.

import React, { useState, useEffect } from 'react';

var EVENT_NAME = 'autodex-buyer-toast';
var DEFAULT_MS = 2400;

export function showToast(message, opts) {
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: { message: message, variant: (opts && opts.variant) || 'info', ms: (opts && opts.ms) || DEFAULT_MS },
    }));
  } catch (e) {}
}

export function ToastHost() {
  var [list, setList] = useState([]);

  useEffect(function() {
    function onToast(e) {
      var d = e.detail || {};
      var id = Date.now() + ':' + Math.random().toString(36).slice(2, 7);
      var item = { id: id, message: d.message || '', variant: d.variant || 'info' };
      setList(function(prev){ return prev.concat(item); });
      setTimeout(function(){
        setList(function(prev){ return prev.filter(function(x){ return x.id !== id; }); });
      }, d.ms || DEFAULT_MS);
    }
    window.addEventListener(EVENT_NAME, onToast);
    return function() { window.removeEventListener(EVENT_NAME, onToast); };
  }, []);

  if (list.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 1100,
      display: 'flex', flexDirection: 'column', gap: 8,
      pointerEvents: 'none',    }}>
      {list.map(function(it) {
        var c = it.variant === 'error'
          ? { bg: '#fef2f2', border: '#fecaca', color: '#991b1b' }
          : it.variant === 'success'
            ? { bg: '#ecfdf5', border: '#a7f3d0', color: '#065f46' }
            : { bg: '#1B3A5C', border: '#1B3A5C', color: 'white' };
        return (
          <div key={it.id} style={{
            background: c.bg, color: c.color,
            border: '1px solid ' + c.border,
            padding: '10px 16px', borderRadius: 10,
            fontSize: 13, fontWeight: 600,
            boxShadow: '0 6px 16px rgba(15,23,42,0.12)',
            maxWidth: 320, pointerEvents: 'auto',
            animation: 'autodex-toast-in 0.22s ease-out',
          }}>{it.message}</div>
        );
      })}
      <style>{'@keyframes autodex-toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }'}</style>
    </div>
  );
}

export default ToastHost;
